// OneTrust consent helpers. The inline pixels in public/index.html are gated by
// OneTrust itself (type="text/plain" class="optanon-category-C0004"); tags we
// load from React (GA, Floodlight, TikTok) have to check consent themselves.

// C0004 = Targeting / advertising cookies
export const TARGETING_CATEGORY = "C0004";

export function hasTargetingConsent() {
  return String(window.OnetrustActiveGroups || "").includes(TARGETING_CATEGORY);
}

// index.html dispatches this from OptanonWrapper, which OneTrust calls on load
// and after every consent change. Returns an unsubscribe function.
export function onConsentChange(listener) {
  window.addEventListener("onetrust-consent", listener);

  return () => window.removeEventListener("onetrust-consent", listener);
}

// Set once App has initialized GA/Floodlight, so the route tracker knows it can
// send pageviews (rather than relying on a react-ga4 internal).
let analyticsStarted = false;

export function markAnalyticsStarted() {
  analyticsStarted = true;
}

export function isAnalyticsStarted() {
  return analyticsStarted;
}

export function openCookiePreferences() {
  if (window.OneTrust && typeof window.OneTrust.ToggleInfoDisplay === "function") {
    window.OneTrust.ToggleInfoDisplay();
  }
}
